<div class="nimbus-grid-pager-wrapper">
  <ul class="nimbus-grid-pager-pages">
    @if (start > 1 && !isLazyLoadingEnabled) {
      <li (click)="changePageIndex(start - 2)" [title]="start - 1">...</li>
    }
    @for (page of buttons; track page) {
      <li (click)="changePageIndex(page - 1)" [class.selected]="page === pageIndex + 1" [title]="page">
        {{ page }}
      </li>
    }
    @if (end < totalPages && !isLazyLoadingEnabled) {
      <li (click)="changePageIndex(end)" [title]="end + 1">...</li>
    }
  </ul>

  <mat-paginator
    [length]="total"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [hidePageSize]="true"
    [showFirstLastButtons]="showFirstLastButtons"
    (page)="pageChange($event)"
  ></mat-paginator>
</div>
